import { useCallback, useEffect, useState } from 'react';
import useAlert from '../components/Alerts/useAlert';
import { fetchDataAuthenticated } from '../utilities/HttpUtils';

export function useJobs(siteId) {
    const [jobs, setJobs] = useState();
    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const { setAlert } = useAlert();

    const getJobs = useCallback((siteId) => {
        setLoading(true);

        let url = "api/jobs";
        if (siteId) {
            url += `?siteId=${siteId}`;
        }

        fetchDataAuthenticated(url)
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error(await response.text());
            })
            .then(data => {
                setJobs(data);
            })
            .catch(error => {
                setError(error.message)
                setAlert("danger", "Error", error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        getJobs(siteId);
    }, [getJobs, siteId]);

    return { jobs, setJobs, loading, error }
}

export function useCheckoutJob() {
    const [loading, setLoading] = useState();
    const { setAlert } = useAlert();

    async function checkoutJob(job) {
        let updatedJob;
        setLoading(true);

        await fetchDataAuthenticated(`api/jobs/${job.id}/checkout`, "POST", JSON.stringify(job))
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error(await response.text());
            })
            .then(data => {
                updatedJob = data;
            })
            .catch(error => {
                console.error(error.message);
                setAlert("danger", "Error", "Failed to checkout job", error.message);
            })
            .finally(() => {
                setLoading(false);
            });

        return updatedJob;
    }

    async function undoCheckoutJob(job) {
        let updatedJob;
        setLoading(true);

        await fetchDataAuthenticated(`api/jobs/${job.id}/undoCheckout`, "POST", JSON.stringify(job))
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error(await response.text());
            })
            .then(data => {
                updatedJob = data;
            })
            .catch(error => {
                console.error(error.message);
                setAlert("danger", "Error", "Failed to undo checkout job", error.message);
            })
            .finally(() => {
                setLoading(false);
            });

        return updatedJob;
    }

    return { checkoutJob, undoCheckoutJob, loading }
}

export function useCompleteJob() {
    const [loading, setLoading] = useState();
    const { setAlert } = useAlert();

    async function completeJob(job) {

        setLoading(true);
        let completedJob;

        await fetchDataAuthenticated(`api/jobs/${job.id}/complete`, "POST", JSON.stringify(job))
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error(await response.text());
            })
            .then(data => {
                completedJob = data;
            })
            .catch(error => {
                console.error(error.message);
                setAlert("danger", "Error", "Failed to complete job", error.message);
            })
            .finally(() => {
                setLoading(false);
            });

        return completedJob;
    }

    return { completeJob, loading }
}

export function useCreateAdHocJob() {
    const [loading, setLoading] = useState();
    const { setAlert } = useAlert();

    async function createAdHocJob(job) {

        setLoading(true);
        let createdJob;

        await fetchDataAuthenticated(`api/jobs/adhoc`, "POST", JSON.stringify(job))
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error(await response.text());
            })
            .then(data => {
                createdJob = data;
            })
            .catch(error => {
                console.error(error.message);
                setAlert("danger", "Error", "Failed to create ad hoc job", error.message);
            })
            .finally(() => {
                setLoading(false);
            });

        return createdJob;
    }

    return { createAdHocJob, loading }
}

export function useDeleteJob() {
    const [loading, setLoading] = useState();
    const { setAlert } = useAlert();

    async function deleteJob(job) {
        setLoading(true);

        await fetchDataAuthenticated(`api/jobs/${job.id}`, "DELETE")
            .then(async response => {
                if (response.ok) {
                    return;
                }
                throw new Error(await response.text());
            })
            .then(() => {
                setAlert("success", "Success", 'Deleted job');
            })
            .catch(error => {
                console.error(error.message);
                setAlert("danger", "Error", `Failed to delete job ${job.valveId}`, error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return { deleteJob, loading }
}